import { findAnswerTargetElement } from 'lib/answerTargetScroll'

const TITLE_ANSWER_SELECTOR = '[data-answer-role="title"]'
const QUEST_FRAME_SELECTOR = '[data-qa-scroll-quest-frame="true"]'
const ANSWER_BREADCRUMB_SELECTOR = '[data-answer-breadcrumb="true"]'
const QUEST_CARD_SELECTOR = '[data-quest-card="true"]'

export function findAnswerHighlightElement(
    root: ParentNode | null | undefined,
    answerId: string,
): Element | null {
    const answerTarget = findAnswerTargetElement(root, answerId)
    if (!answerTarget) return null

    if (answerTarget.classList.contains('answer-highlight')) return answerTarget
    return (
        answerTarget.querySelector('.answer-highlight') || answerTarget.closest('.answer-highlight')
    )
}

export function getAnswerHighlightTargets(answerElement: Element): Element[] {
    const targets = [answerElement]

    if (!answerElement.closest(TITLE_ANSWER_SELECTOR)) return targets

    // Only inside a stream card, where the breadcrumb and the title are two
    // halves of one card — the same pairing the card's hover state makes. In a
    // thread panel that breadcrumb is the panel's parent-crumb header, and
    // flashing it alongside the post reads as a second, unrelated highlight.
    const frame = answerElement.closest(QUEST_FRAME_SELECTOR)
    if (!frame?.matches?.(QUEST_CARD_SELECTOR)) return targets

    const breadcrumb = frame.querySelector(ANSWER_BREADCRUMB_SELECTOR)
    if (breadcrumb) targets.push(breadcrumb)

    return targets
}
